// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { IdentifierType } from './identifierType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class GetMedicareReportRequestModel {
    'identifierType': IdentifierType;
    'identifierValue': string;
    'prescriberState'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof GetMedicareReportRequestModel>> = [
        {
            "name":     "identifierType",
            "baseName": "identifierType",
            "type":     "IdentifierType"
        },
        {
            "name":     "identifierValue",
            "baseName": "identifierValue",
            "type":     "string"
        },
        {
            "name":     "prescriberState",
            "baseName": "prescriberState",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return GetMedicareReportRequestModel.attributeTypeMap;
    }
}
